import moment from "moment";
import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import {
    ApplicationEnum,
    Gender,
    PatientStatus,
    PatientStatusEnum,
    PermissionActionEnum,
    Veterans
} from "../../../../../enums/enums";
import { formatDate } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { getHospiceRedirectionUrl } from "../../../../../common/get-hospice-redirection-url";
import { BranchesService } from "../../../../../services/branches-service";
import { formatName } from "../../../../../common/format-name";
import { CodeStatus } from "../../../../../enums/ReferralEnums/CodeStatusEnum";
import { PermissionManager } from "../../../../../common/utilities/permission-manager";
import { ClinicalPermissionEnum } from "../../../../../enums/ClinicalPermissionsEnum";

import HosPalPatientMain from "../HosPalPatientMain/HosPalPatientMain.vue";

export default defineComponent({
    components: {
        HosPalPatientMain
    },
    props: {
        selectedPatientDetails: {
            default: null
        },
        application: {
            type: Number
        },
        agencyId: {
            type: String
        }
    },
    data(vm) {
        return {
            _permissionManager: null as PermissionManager,
            _branchesService: null as BranchesService,
            allBranches: [],
            veteranEnum: Veterans,
            statusEnum: PatientStatus,
            genderEnum: Gender,
            isDoNotResuscitate: false,
            isDoNotIntubate: false,
            isDoNotHospitalize: false,
            canShowBenefitPeriodManager: false,
            ApplicationEnum,
            moment,
            formatDate,
            getHospiceRedirectionUrl,
            formatName
        };
    },
    async created() {
        this._branchesService = Container.instance.get(BranchesService);
        this._permissionManager = Container.instance.get(PermissionManager);
        this.allBranches = await this._branchesService.getAllBranches();
        this.initAdvancedCarePlanDirectives();
        this.canShowBenefitPeriodManager = this._permissionManager.checkPermission(
            ClinicalPermissionEnum.ManageBenefitPeriod,
            PermissionActionEnum.canView
        );
    },
    computed: {
        getBranchName() {
            return this.allBranches.find((branch) => branch.id === this.selectedPatientDetails?.branchId);
        },
        age() {
            if (!!this.selectedPatientDetails?.dateOfBirth) {
                let today = moment();
                let mDob = moment(this.selectedPatientDetails.dateOfBirth);
                let age = today.diff(mDob, "years");
                if (age < 2) {
                    let newAge = today.diff(mDob, "months");
                    if (newAge < 1) {
                        newAge = today.diff(mDob, "days");
                        return `${newAge} Days Old`;
                    }
                    return `${newAge} Months Old`;
                }
                return `${age} Years Old`;
            } else {
                return "";
            }
        },
        veteranLabel() {
            let veteranValue = this.selectedPatientDetails.veterans?.map((item) => Veterans.getKeyUsingValue(item));
            return veteranValue.join(", ");
        },
        patientTags() {
            return this.selectedPatientDetails.patientTags?.map((tag) => tag.Name).join(", ");
        },
        allergyCount() {
            return this.selectedPatientDetails.allergies?.filter((allergy) => !allergy.endDate).length;
        },
        isPendingPatient() {
            return this.selectedPatientDetails.status === PatientStatusEnum.pending;
        },
        terminalDiagnosis() {
            return this.selectedPatientDetails.diagnoses.find((diagnosis) => {
                return diagnosis.Order === 1 && !!diagnosis.Code && !!diagnosis.Description;
            });
        }
    },
    methods: {
        async initAdvancedCarePlanDirectives() {
            [this.isDoNotResuscitate, this.isDoNotIntubate, this.isDoNotHospitalize] = [false, false, false];
            for (const directiveNumber of this.selectedPatientDetails.codeStatus) {
                const directiveName = (CodeStatus.getKeyUsingValue(directiveNumber) as string).toLocaleLowerCase();
                switch (directiveName) {
                    case "do not resuscitate":
                        this.isDoNotResuscitate = true;
                        break;
                    case "do not intubate":
                        this.isDoNotIntubate = true;
                        break;
                    case "do not hospitalize":
                        this.isDoNotHospitalize = true;
                        break;
                    default:
                        break;
                }
            }
        }
    }
});
